export const PAGE_KEY: string = 'actionUrl';
